import { SelectionState, AtomicBlockUtils, EditorState, Modifier } from "draft-js";
import { insertHtml, insertBlock, findBase } from "lib/helpers";
import { cleanHtml } from "./cleanHtml";

export function createResultBuilder(name, fileType) {
	switch(fileType) {
		case 'word': return createWordResutBuilder(name, fileType);
		case 'ppt': return createGalleryResultBuilder(name, fileType);
		case 'pdf':
		case 'zip': return createAttachmentResultBuilder(name, fileType);
	}
}

function createWordResutBuilder() {
	let html = '';
	return {
		next: preview => html += cleanHtml(preview.pageHtml),
		/**
		 *
		 * @param {DraftEditorStore} store
		 * @param {Draft.ContentBlock} block
		 */
		execute(store, block) {
			const insertSelection = new SelectionState({
				anchorKey: block.getKey(),
				anchorOffset: 0,
				focusKey: block.getKey(),
				focusOffset: block.getLength(),
			});
			insertHtml(store, insertSelection, html);
		}
	}
}

function createGalleryResultBuilder(name) {
	let images = [];
	return {
		next: preview => images.push(preview.pageImage),
		/**
		 *
		 * @param {DraftEditorStore} store
		 * @param {Draft.ContentBlock} block
		 */
		async execute(store, block) {
			if (!images.length) return;
			const base = findBase(images);
			images = images.map(image => image.slice(base.length));
			const entityData = { name, base, images };
			replaceWithAtomic(store, block, name, 'GALLERY', entityData);
		}
	};
}

function createAttachmentResultBuilder(name) {
	let url = null;
	return {
		next: preview => url = url || preview.url,
		execute(store, block) {
			if (!url) return;
			replaceWithAtomic(store, block, name, 'ATTACHMENT', { name, url });
		}
	}
}

/**
 *
 * @param {DraftEditorStore} store
 * @param {Draft.ContentBlock} block
 */
function replaceWithAtomic(store, block, name, entityType, entityData) {
	const selection = new SelectionState({
		anchorKey: block.getKey(),
		anchorOffset: 0,
		focusKey: block.getKey(),
		focusOffset: block.getLength(),
	});
	const editorState = store.getEditorState();
	const content = editorState.getCurrentContent()
		.createEntity(entityType, 'IMMUTABLE', entityData);

	const entityKey = content.getLastCreatedEntityKey();

	store.setEditorState(
		AtomicBlockUtils.insertAtomicBlock(
			EditorState.set(editorState, {
				currentContent: Modifier.setBlockType(
					Modifier.removeRange(content, selection, 'forward'),
					selection,
					'unstyled'
				),
				selection,
			}),
			entityKey,
			name,
		)
	);
}



// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/fileImportPlugin/modifier/resultBuilder.js